import {Component, EventEmitter, Output, AfterContentInit}  from '@angular/core';
import {NgbDateStruct, NgbCalendar, NgbDatepickerConfig}    from '@ng-bootstrap/ng-bootstrap';

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
	!one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
		? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
	!one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
		? false : one.day > two.day : one.month > two.month : one.year > two.year;


@Component({
	selector: 'datepicker-range',
	providers: [NgbDatepickerConfig],
	templateUrl: './datepicker-range.component.html',
	styles: [`
        .custom-day {
            text-align: center;
            padding: 0.185rem 0.25rem;
            display: inline-block;
            height: 2rem;
            width: 2rem;
        }

        .custom-day.focused {
            background-color: #e6e6e6;
        }

        .custom-day.range, .custom-day:hover {
            background-color: #0275d8;
            color: white;
        }

        .faded {
            opacity: 0.5;
        }
	`]
})


/**
 * A component that displays two months'
 * worth of dates and allows the selection
 * of a single date or a date range.
 */
export class DatepickerRangeComponent implements AfterContentInit {


	fromDate: NgbDateStruct = null;
	hoveredDate: NgbDateStruct;
	toDate: NgbDateStruct = null;


	/**
	 * Initialize the calendar settings.
	 *
	 * @param config    The calendar configuration object.
	 * @param calendar  The calendar object.
	 */
	constructor(

		config: NgbDatepickerConfig,
		calendar: NgbCalendar,

	) {

		// this.fromDate = calendar.getPrev(calendar.getToday(), 'd', 3);
		// this.toDate = calendar.getToday();
		this.fromDate = calendar.getToday();
		let cDate: Date = new Date();
		let month:number = cDate.getMonth() + 1;
		config.maxDate = {'day': cDate.getDate(), 'month': month, 'year': cDate.getFullYear()};
		config.displayMonths = 3;   // This setting doesn't work; must be set on template.
		config.firstDayOfWeek = 7;  // This setting doesn't work; must be set on template.
		config.navigation = "arrows";
		config.outsideDays = "hidden";

		// Show most recent 3 months.
		if (month < 3) {

			config.startDate = {'year': cDate.getFullYear() - 1, 'month' : 12 - (2 - month)}

		} else {

			config.startDate = {'year': cDate.getFullYear(), 'month' : month - 2}

		}

	}


	/**
	 * Pass back the initial values of the datepicker,
	 * but only after the component has been initialized.
	 */
	ngAfterContentInit(): void {

		this.from.emit(this.fromDate);
		this.to.emit(this.toDate);

	}


	/**
	 * Output the from date to the host page.
	 * @type {EventEmitter<NgbDateStruct>}
	 */
	@Output()
	from: EventEmitter<NgbDateStruct> = new EventEmitter<NgbDateStruct>();


	/**
	 * Output the to date to the host page.
	 *
	 * @type {EventEmitter<NgbDateStruct>}
	 */
	@Output()
	to: EventEmitter<NgbDateStruct> = new EventEmitter<NgbDateStruct>();


	/**
	 * Handle date change events.
	 *
	 * @param {NgbDateStruct} date  The structured date value.
	 */
	onDateChange(date: NgbDateStruct) {

		if (!this.fromDate && !this.toDate) {

			this.fromDate = date;

		} else if (this.fromDate && !this.toDate && after(date, this.fromDate)) {

			this.toDate = date;

		} else {

			this.toDate = null;
			this.fromDate = date;

		}

		// Output the new values.
		this.from.emit(this.fromDate);
		this.to.emit(this.toDate);

	}

	isHovered = (date: NgbDateStruct) => this.fromDate && !this.toDate && this.hoveredDate && after(date, this.fromDate) && before(date, this.hoveredDate);
	isInside = (date: NgbDateStruct) => after(date, this.fromDate) && before(date, this.toDate);
	isFrom = (date: NgbDateStruct) => equals(date, this.fromDate);
	isTo = (date: NgbDateStruct) => equals(date, this.toDate);

}



// WEBPACK FOOTER //
// ./src/app/articles/feed/news/datepicker/datepicker-range.component.ts